import React from 'react'
import '../../Css/Savani.css'
import kalathiya from '../../Image/kalathiya_txt.svg'
import insta from '../../Image/insta.svg'
import face from '../../Image/face.svg'
import google from '../../Image/about_google.svg'
import linkdin from '../../Image/about_linkdin.svg'
import youtube from '../../Image/youtube.svg'


const AboutStart = () => {
  return (
          <div className='bg-[#F6F6F6] '>
              <div className='container pb-5'>
              <div className='lg:hidden block'>
                  <div className='flex  pt-4 '>
                            <a href='https://www.facebook.com/kalathiyainfotech' target='_blank' className='ds_round ds_round_active flex justify-center align-middle me-3'>
                               <img src={face} alt="" className='ds_round_svg' />
                            </a>
                            <a href='https://www.instagram.com/kalathiya_infotech/' target='_blank' className='ds_round flex justify-center align-middle me-3'>
                               <img src={insta} alt="" />
                            </a>
                            <a href='https://www.google.com/search?q=kalathiya+infotech' target='_blank' className='ds_round flex justify-center align-middle me-3'>
                               <img src={google} alt="" />
                            </a>
                            <a href='https://www.linkedin.com/company/kalathiyainfotech/' target='_blank' className='ds_round flex justify-center align-middle me-3'>
                               <img src={linkdin} alt="" />
                            </a>
                            <a href='https://www.youtube.com/@KalathiyaInfotech' target='_blank' className='ds_round flex justify-center align-middle '>
                               <img src={youtube} alt="" />
                            </a>
                   </div>
               </div>
               <div className='md:pt-[130px] pt-[80px] container relative '>
               <h2 className="md:text-[60px] sm:text-[40px] sx:text-[30px] text-[28px] font-[700] text-theme_dark text-center"> About Us</h2>
              <div className='flex justify-center mt-4 relative sm:top-[20px] top-[10px]'>
                  <img src={kalathiya} alt="" />
              </div>
              <div className='lg:block hidden'>
                  <div className='absolute top-[20%] right-0  flex flex-col justify-center'>
                     <div>
                        <a href='https://www.facebook.com/kalathiyainfotech' target='_blank' className='ds_round custom_hover flex justify-center align-middle mb-2'>
                           <img src={face} alt="" className='ds_round_svg' />
                        </a>
                        <a href='https://www.instagram.com/kalathiya_infotech/' target='_blank' className='ds_round custom_hover flex justify-center align-middle mb-2'>
                           <img src={insta} alt="" className='ds_round_svg' />
                        </a>
                        <a href='https://www.google.com/search?q=kalathiya+infotech' target='_blank' className='ds_round custom_hover flex justify-center align-middle mb-2'>
                           <img src={google} alt="" className='ds_round_svg' />
                        </a>
                        <a href='https://www.linkedin.com/company/kalathiyainfotech/' target='_blank' className='ds_round custom_hover flex justify-center align-middle mb-2'>
                           <img src={linkdin} alt="" className='ds_round_svg' />
                        </a>
                        <a href='https://www.youtube.com/@KalathiyaInfotech' target='_blank' className='ds_round custom_hover flex justify-center align-middle mb-2'>
                           <img src={youtube} alt="" className='ds_round_svg' />
                        </a>
                     </div>
                     <div className='lg:block hidden'>
                        <div className='flex justify-center mt-3 '>
                           <div className='w-[1px] h-[80px] bg-theme_dark'></div>
                        </div>
                     </div>
                  </div>
              </div>
               </div>
              </div>
          </div>
  )
}

export default AboutStart
